import { useAppDispatch } from 'app/config/storeConfig/hooks';
import { useGetUnitsQuery } from 'entities/Box';
import { useGetWarehousesForBookingQuery } from 'entities/Warehouse';
import { bookingPageActions } from '../../model/slice/bookingPageSlice';
import { useEffect, useRef } from 'react';
import { useQueryString } from 'shared/utils/helpers/convertQueryString';
import { BookingSteps, bookingHeaderActions } from 'widgets/BookingHeader';
import { warehouseMapActions } from 'widgets/SelectWarehouseMap';
import { UnitType } from 'entities/Contract';
import { setBookingDataToLocalStorage } from '../helpers/setBookingDataToLocalStorage';
import { useNavigate } from 'react-router-dom';

export const useSetBookingDataFromQuery = (): void => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    parsedQuery: { warehouseId, boxId, sizeCodeId },
  } = useQueryString();

  const { data: warehouses } = useGetWarehousesForBookingQuery();
  const { data: boxesData } = useGetUnitsQuery({ sizeCodeId, isAvailable: true, unitType: UnitType.BOX }, { skip: !sizeCodeId });

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current || !warehouseId || !warehouses) {
      return;
    }

    const selectedWarehouse = warehouses.find((w) => w.warehouseId === warehouseId);
    const selectedBox = boxesData?.content.find((box) => box.boxId === boxId);

    if (selectedWarehouse) {
      dispatch(warehouseMapActions.setSelectedCard(warehouseId));
      dispatch(bookingPageActions.setWarehouseInfo(selectedWarehouse));
      dispatch(bookingHeaderActions.changeActiveStep(BookingSteps.SELECT_UNIT));
      setBookingDataToLocalStorage({ warehouseId }, navigate);
    }

    if (selectedBox) {
      dispatch(
        bookingPageActions.setBoxInfo({
          selectedBox,
          selectedSizeCodeId: selectedBox.sizeCode.sizeCodeId,
        }),
      );
      dispatch(bookingHeaderActions.changeActiveStep(BookingSteps.CONTRACT_INFORMATION));
      setBookingDataToLocalStorage({ sizeCodeId: selectedBox.sizeCode.sizeCodeId, boxId: selectedBox.boxId }, navigate);
    }

    hasInitialized.current = true;
  }, [warehouseId, sizeCodeId, boxId, warehouses, boxesData, dispatch, navigate]);
};
